import Landing from '@app/components/Landing'

export default {
  Landing: {
    component: Landing,
    exact: true,
    path: '/'
  },
  Shares: {
    component: Landing,
    path: '/shares/:social'
  }
}
